import { Link } from "@inertiajs/react";
import { getBibleLinkProps } from "./routing";

interface BibleLinkProps {
  currentTranslationSlug: string;
  currentBookSlug: string;
  currentChapterNumber: number | string;
  translationSlug?: string;
  bookSlug?: string;
  chapterNumber?: number | string;
  verseNumber?: number | string;
  clearQuery?: boolean;
  style?: React.CSSProperties;
  className?: string;
  ref?: React.Ref<HTMLAnchorElement>;
  'aria-current'?: React.AriaAttributes['aria-current'];
  onClick?: () => void;
  children: React.ReactNode;
}

export default function BibleLink({
  currentTranslationSlug,
  currentBookSlug,
  currentChapterNumber,
  translationSlug,
  bookSlug,
  chapterNumber,
  verseNumber,
  clearQuery,
  style,
  className,
  ref,
  'aria-current': ariaCurrent,
  onClick,
  children,
}: BibleLinkProps) {
  const { href, preserveState, only } = getBibleLinkProps(
    {
      translationSlug: currentTranslationSlug,
      bookSlug: currentBookSlug,
      chapterNumber: currentChapterNumber,
    },
    {
      translationSlug,
      bookSlug,
      chapterNumber,
      verseNumber,
      clearQuery,
    }
  );

  return (
    <Link
      href={href}
      preserveState={preserveState}
      only={only}
      style={style}
      className={className}
      ref={ref}
      aria-current={ariaCurrent}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
